import {
	SHOW_OVERLAY,
	HIDE_OVERLAY
} from "../../constants"

export const showOverlay = ( message ) => {
	return {
		type: SHOW_OVERLAY,
		payload: {
			message: message
		}
	}
};

export const hideOverlay = () => {
	return {
		type: SHOW_OVERLAY,
		payload: {
			message: ''
		}
	}
};


// WEBPACK FOOTER //
// ./src/api/overlay/actions.js